import { render, staticRenderFns } from "./ReportForPaymentScreen.vue?vue&type=template&id=8afcdb70&scoped=true"
import script from "./ReportForPaymentScreen.vue?vue&type=script&lang=js"
export * from "./ReportForPaymentScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afcdb70",
  null
  
)

export default component.exports